/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatientGetPatientImage$Params {
  practiceId?: string | null;
  personId?: string | null;
}

export function patientGetPatientImage(http: HttpClient, rootUrl: string, params?: PatientGetPatientImage$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, patientGetPatientImage.PATH, 'get');
  if (params) {
    rb.query('practiceId', params.practiceId, {});
    rb.query('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

patientGetPatientImage.PATH = '/patient/GetPatientImage';
